<template>
    <div>
        <div>
            <div class="pb-24">
                <h2 class="text-xl pb-3">Signature Required</h2>
                <!--<span class="pb-4 text-lg block">{{userMessage}}</span>-->
                <div v-if="message">
                    <span>{{message}}</span>
                </div>
                <div v-else>
                    <span class="text-base mb-4 text-blue-900 block">You'll need to accept or decline the signature within {{timeLeft}} seconds.</span>
                    <button @click="signTransaction(true)" class="font-bold bg-green-600 rounded text-white py-2 px-8 mr-6">Accept</button>
                    <button @cick="signTransaction(false)" class="font-bold bg-red-600 rounded text-white py-2 px-8 ">Reject</button>
                </div>
            </div>
            <!--<Spinner />-->
        </div>
    </div>
</template>

<script>

    import Spinner from './../components/Spinner.vue';
    import sendToVend from './../js/vendMessages';
    import pollTerminal from './../js/pollTerminal';

    export default {
        name: 'PaymentSignature',
        components: {
            Spinner
        },
        created() {
            this.countDownTimer();
        },
        data () {
            return {
                message: '',
                timeLeft: 60
            }
        },
        methods: {
            countDownTimer() {
                if(this.timeLeft > 0) {
                    setTimeout(() => {
                        this.timeLeft -= 1
                        this.countDownTimer()
                    }, 1000)
                }
            },
            signTransaction(accept) {
                let tid = this.$route.query.tid;
                let transactionId = this.$route.query.transactionId
                let data = {
                    "accepted": accept
                };

                this.axios({
                    method: 'PUT',
                    url: 'https://uk1.storekitpayments.com' + '/api/v1/pay-at-counter/terminals/' + tid + '/transactions/' + transactionId + '/signature',
                    headers: {'Authorization': 'Basic dGVzdDp0ZXN0'},
                    data: data
                })
                    .then((response) => {
                        let txnId = {
                            "data": {
                                "result": {
                                    "transaction_id": ''
                                }
                            }
                        };
                        txnId.data.result.transaction_id = transactionId;
                        console.log(txnId)
                        pollTerminal(txnId)
                    })
                    .catch((error) => {
                        if (error.response && error.response.status == 422) {
                            this.message = "Sorry, signature authorisations must be performed within 60 seconds. The payment has been auto-declined."
                            this.$router.push('/failed');
                        }
                        console.log(error);
                    })
            }
        }
    }
</script>

